export const defaultMetrics = {
  facilitatorCount: 0,
  programCount: 0,
  submittedApplicationsCount: 0,
  assignedPendingApplicationCount: 0,
}
